import { useContext } from "react";
import { JobClassContext } from "contexts/JobClassContext";

const useJobClass = () => { 
    const context = useContext(JobClassContext);
    return context;
};

export default useJobClass;